import { Configuration, PopupRequest, LogLevel } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: 'b9dd1e8f-0ae5-4d52-8b53-ff9f2c9a774e',
    authority: 'https://login.microsoftonline.com/67bddb59-fadf-4655-81df-6596e41b96a0',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (import.meta.env.DEV) {
          switch (level) {
            case LogLevel.Error:   console.error(message); break;
            case LogLevel.Warning: console.warn(message);  break;
            case LogLevel.Info:    console.info(message);  break;
            default:               console.debug(message); break;
          }
        }
      },
    },
  },
};

// Scopes mínimos para login - ampliamos conforme integrações ficam prontas
export const loginRequest: PopupRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    'User.Read',
  ],
};

// Scope para Graph (SharePoint, Mail) - ativar nas sessões de integração
export const graphRequest = {
  scopes: ['User.Read'],
};

// Scope para a API backend - ativar após expor a API no Azure AD (Sessão 4+)
export const apiRequest = {
  scopes: ['User.Read'],
};

// SPEC 1 - scope para listar usuários do tenant (tela de admin)
// User.Read.All (delegado) retorna assignedLicenses de terceiros; admin consent concedido no tenant EJFA.
export const adminGraphRequest = {
  scopes: ['User.Read.All'],
};
